import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[pDynamicDialogFooter]',
  standalone: false,
})
export class DynamicDialogFooter {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
